import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  TableLoader,
} from "../../../components/commons";
import RecurringJobReportHeader from "../../../components/Jobs/RecurringJobReport/RecurringJobReportHeader";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import {
  getAllFinacManagerAction,
  getAllFinacUsersAction,
  resetFinacManagerList,
  resetFinacUsersList,
  resetTotalManagerCount,
} from "../../../redux/auth";
import useDebounce from "../../../customHooks/useDebounce";
import {
  getRecurringJobReportAction,
  resetRecurringJobReportList,
  resetRecurringJobReportTotalCount,
} from "../../../redux/jobs";
import { EmptyTimeSheetReportList } from "../../../assets/images";
import RecurringJobReportTable from "../../../components/Jobs/RecurringJobReport/RecurringJobReportTable";
import FileSaver from "file-saver";
import { downloadRecurringJobReportApi } from "../../../apis/jobsApis";
import toast from "react-hot-toast";
import {
  DownloadRecurringJobReportPayloadType,
  GetRecurringJobReportPayloadType,
} from "../../../commonTypes/listing";
import { RecurringJobReportListType } from "../../../redux/jobs/jobsType";
import { FinacUsersType } from "../../../redux/auth/authTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

export type DropDownUserType = {
  value: number | null;
  label: string;
};
type AppProps = {
  token: string | null;
  history: any;
  fetching: boolean;
  managerFetching: boolean;
  finacManagerList: [] | FinacUsersType[];
  totalManagerCount: any;
  finacUser: any;
  userFetching: boolean;
  recurringJobReportTotalCount: number;
  recurringJobReportList: RecurringJobReportListType[]|[];
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetFinacManagerList: () => void;
  dispatchResetTotalManagerCount: () => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetFinacUsersList: () => void;
  dispatchGetRecurringJobReportAction: (
    data: GetRecurringJobReportPayloadType
  ) => void;
  dispatchResetRecurringJobReportList: () => void;
  dispatchResetRecurringJobReportTotalCount: () => void;
};
const RecurringJobReport = ({
  token,
  history,
  fetching,
  managerFetching,
  finacManagerList,
  totalManagerCount,
  finacUser,
  userFetching,
  recurringJobReportTotalCount,
  recurringJobReportList,
  dispatchGetAllFinacManagerAction,
  dispatchResetFinacManagerList,
  dispatchResetTotalManagerCount,
  dispatchGetAllFinacUsersAction,
  dispatchResetFinacUsersList,
  dispatchGetRecurringJobReportAction,
  dispatchResetRecurringJobReportList,
  dispatchResetRecurringJobReportTotalCount,
}: AppProps) => {
  const [finalManagerList, setFinalManagerList] = useState<any>([]);
  const [managerText, setManagerText] = useState<string>("");
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);
  const [manager, setManager] = useState<DropDownUserType>({
    label: "Select...",
    value: null,
  });

  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [offset, setoffset] = useState<number>(0);
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [currentlyResponsible, setCurrentlyResponsible] = useState<DropDownUserType>({
    label: "Select...",
    value: null,
  });
    const [data, setData] = useState<any[] | []>([]);


    //====================User Management=============================
      const [isDownloadRecurringJobReportPresent, setIsDownloadRecurringJobReportPresent] =
        useMenuCheck();
  
    
    //=================================================================

  useEffect(() => {
    dispatchResetRecurringJobReportList();
    dispatchResetRecurringJobReportTotalCount();
    dispatchResetFinacUsersList();
    dispatchResetFinacManagerList();
    setIsDownloadRecurringJobReportPresent("Download Recurring Job Report", "menu")

  }, []);


  useEffect(() => {
    if (recurringJobReportList?.length === 0) {
      setData(recurringJobReportList? [...recurringJobReportList.map((item:any)=>({...item}))] : []);
    }
    else {
      setData(recurringJobReportList ? [...recurringJobReportList?.map((item:any)=>({...item}))] : []);
    }
  }, [recurringJobReportList]);


  useEffect(() => {
    const finalManagerData = finacManagerList?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }%${user?.job_title ? user?.job_title : ""} ${
          user?.department ? "|" : ""
        } ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: "manager",
        status: 1,
        search_term: managerText,
      };
      if (managerOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [managerOffset]);

  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: "manager",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };

  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: managerOffset,
          limit: managerLimit,
          user_type: "manager",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""}%${user?.job_title ? user?.job_title : ""} ${user?.department ? "|" : ""} ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (offset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        user_type: "stco_users",
        search_term: text,
      };
      if (offset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      user_type: "stco_users",
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          user_type: "stco_users",
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  const handleCurrentlyResponsibleChange=(e:any)=>{
  setCurrentlyResponsible({
    value:e?.value,
    label: e?.label?.split("%")[0]

  })
  }

  const handleManagerChange =(e:any)=>{
  setManager({
    value:e?.value,
    label: e?.label?.split("%")[0]
  })
  }

  const handleSubmitData = () => {
    if (token) {
      let finalData: GetRecurringJobReportPayloadType = {
        token,
        manager: manager?.value,

        currently_responsible: currentlyResponsible?.value,
      };
      dispatchGetRecurringJobReportAction(finalData);
    }
  };

  const handleRedirectToRecurringJobSetting = (data: any) => {
    history.push({
      pathname: `/jobs/recurring-jobs/edit/${data?.clientCode}`,
      state: { companyName: data?.companyName, clientCode: data?.clientCode },
    });
  };

  const handleDownload = (params: DownloadRecurringJobReportPayloadType) => {
    let reportName = "Recurring_job_report.xlsx";

    let finalApi = downloadRecurringJobReportApi(params);
    finalApi.then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handlePrepareDownload = () => {
    let params: DownloadRecurringJobReportPayloadType = {
      token,
      manager: manager?.value,
      currently_responsible: currentlyResponsible?.value,
    };

    if (params && token) {
      handleDownload(params);
    }
  };

  return (
    <div>
      <CommonHeader title="Recurring Job Report" />
      <div className="new-table-card">
        <div className="row">
          <div className="col-md-12 pl-2 pr-2 mt-4 mb-4">
            {
              <div>
                <div
                  className=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "-16px",
                    marginBottom: "2px",
                  }}
                >
                  <div
                    style={{ marginTop: "5px", marginLeft: "15px" }}
                    className="mt-0 pt-2"
                  >
                    <span
                      className="ml-3"
                      style={{
                        fontWeight: "500",
                        letterSpacing: "0.34px",
                        fontSize: "16px",
                      }}
                    >
                      Recurring Job Report
                    </span>{" "}
                  </div>
                </div>

                {!!recurringJobReportList?.length ? (
                  <div
                    style={{
                      marginLeft: "33px",
                      color: "#7c8db0",
                      fontSize: "14px",
                    }}
                  >
                    {`Total ${recurringJobReportTotalCount} entries found`}
                  </div>
                ) : null}
              </div>
            }

            <RecurringJobReportHeader
              setManagerOffset={setManagerOffset}
              setManagerText={setManagerText}
              managerLimit={managerLimit}
              managerFetching={managerFetching}
              finalManagerList={finalManagerList}
              manager={manager}
              setManager={setManager}
              setOffset={setoffset}
              setLimit={setLimit}
              limit={limit}
              userFetching={userFetching}
              finalUserList={finalUserList}
              currentlyResposible={currentlyResponsible}
              setCurrentlyResposible={setCurrentlyResponsible}
              setText={setText}
              handleSubmitData={handleSubmitData}
              recurringJobReportList={recurringJobReportList}
              handlePrepareDownload={handlePrepareDownload}
              handleCurrentlyResponsibleChange={handleCurrentlyResponsibleChange}
              handleManagerChange={handleManagerChange}
              isDownloadRecurringJobReportPresent={isDownloadRecurringJobReportPresent}
            />
          </div>
        </div>

        <>
          {fetching ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : recurringJobReportList?.length > 0 ? (
            <RecurringJobReportTable
            recurringJobReportList={recurringJobReportList}
            data={data}
            setData={setData}
            handleRedirectToRecurringJobSetting={
              handleRedirectToRecurringJobSetting
            }
          />
          ) : (
            <>
              {!fetching &&
                (!recurringJobReportList ||
                  recurringJobReportList?.length === 0) && (
                  <div className="pb-4 pl-0 pr-0">
                    <EmptyListPage
                      title="No List Found!"
                      imageWidth="30%"
                      image={EmptyTimeSheetReportList}
                      showAddButton={false}
                    />
                  </div>
                )}
            </>
          )}
        </>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.jobs.fetching,
  managerFetching: state.auth.managerFetching,
  finacManagerList: state.auth.finacManagerList,
  totalManagerCount: state.auth.totalManagerCount,
  finacUser: state.auth.finacUsersList,
  userFetching: state.auth.fetching,
  recurringJobReportTotalCount: state.jobs.recurringJobReportTotalCount,
  recurringJobReportList: state.jobs.recurringJobReportList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),

  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),
  dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
  dispatchResetTotalManagerCount: () => dispatch(resetTotalManagerCount()),
  dispatchGetRecurringJobReportAction: (
    data: GetRecurringJobReportPayloadType
  ) => dispatch(getRecurringJobReportAction(data)),
  dispatchResetRecurringJobReportList: () =>
    dispatch(resetRecurringJobReportList()),
  dispatchResetRecurringJobReportTotalCount: () =>
    dispatch(resetRecurringJobReportTotalCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecurringJobReport);
